import { render, staticRenderFns } from "./SendOptions.vue?vue&type=template&id=1ec67e8e&scoped=true&"
import script from "./SendOptions.vue?vue&type=script&lang=js&"
export * from "./SendOptions.vue?vue&type=script&lang=js&"
import style0 from "./SendOptions.vue?vue&type=style&index=0&id=1ec67e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec67e8e",
  null
  
)

export default component.exports